import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Card,
  Typography,
  Button,
  Form,
  Input,
  message,
  Row,
  Modal,
} from "antd";
import { LinkedinOutlined, MailOutlined } from "@ant-design/icons";
import emailjs from "emailjs-com";

const { Title, Paragraph } = Typography;

const AboutMe = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const handleModalOk = () => {
    setIsModalVisible(false);
  };

  const onFinish = (values) => {
    if (values.name.toUpperCase() === "IAMAKHIL") {
      navigate("/login");
      return;
    }

    setLoading(true);
    emailjs
      .send("service_8jylyhp", "template_xa1oliw", values, "aYiVMrWRJdxToo1T3")
      .then(
        () => {
          form.resetFields();
          setIsModalVisible(true);
          setLoading(false);
        },
        (error) => {
          console.error("Email error:", error.text);
          message.error("There was an error submitting your feedback.");
          setLoading(false);
        }
      );
  };

  return (
    <div
      style={{
        background: "#f0f2f5",
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Card
        style={{
          maxWidth: 900,
          width: "100%",
          padding: "30px",
          borderRadius: "10px",
          boxShadow: "0px 10px 20px rgba(0, 0, 0, 0.1)",
        }}
      >
        <Title level={2} style={{ textAlign: "center", color: "#1890ff" }}>
          About Me
        </Title>
        <Paragraph style={{ textAlign: "center", color: "#555" }}>
          Hi! I'm Akhil, a passionate developer working with Temenos T24 and
          frontend solutions. I enjoy building automation tools, portfolio apps,
          and exploring innovative tech.
        </Paragraph>

        <Row justify="center" style={{ marginBottom: "20px" }}>
          <Button
            type="primary"
            icon={<LinkedinOutlined />}
            href="https://www.linkedin.com/in/akhil-mudetthula"
            target="_blank"
            style={{
              backgroundColor: "#0077b5",
              borderColor: "#0077b5",
              padding: "10px 20px",
              fontSize: "16px",
              margin: "0 10px",
            }}
          >
            Connect on LinkedIn
          </Button>
        </Row>

        <Paragraph style={{ textAlign: "center", color: "#555" }}>
          <MailOutlined /> Contact me at:{" "}
          <a href="mailto:akhilmudetthula@gmail.com">
            akhilmudetthula@gmail.com
          </a>
        </Paragraph>

        <Title
          level={4}
          style={{ marginTop: 30, color: "#1890ff", textAlign: "center" }}
        >
          Send Feedback
        </Title>

        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          style={{ maxWidth: 700, margin: "0 auto" }}
        >
          <Form.Item
            name="name"
            label="Name"
            rules={[{ required: true }]}
            style={{ marginBottom: "15px" }}
          >
            <Input
              placeholder="Your name"
              style={{
                borderRadius: "8px",
                padding: "10px",
                borderColor: "#1890ff",
                boxShadow: "0px 0px 5px rgba(24, 144, 255, 0.2)",
              }}
            />
          </Form.Item>

          <Form.Item
            name="email"
            label="Email"
            rules={[{ type: "email", required: true }]}
          >
            <Input
              placeholder="Your email"
              style={{
                borderRadius: "8px",
                padding: "10px",
                borderColor: "#1890ff",
                boxShadow: "0px 0px 5px rgba(24, 144, 255, 0.2)",
              }}
            />
          </Form.Item>

          <Form.Item
            label="Message"
            name="message"
            rules={[{ required: true, message: "Please enter your message!" }]}
            style={{ marginBottom: "15px" }}
          >
            <Input.TextArea
              rows={4}
              placeholder="Your message"
              style={{
                borderRadius: "8px",
                padding: "10px",
                borderColor: "#1890ff",
                boxShadow: "0px 0px 5px rgba(24, 144, 255, 0.2)",
              }}
            />
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              style={{
                width: "100%",
                backgroundColor: "#1890ff",
                borderColor: "#1890ff",
                padding: "12px 0",
                fontSize: "16px",
                borderRadius: "8px",
              }}
            >
              Submit
            </Button>
          </Form.Item>
        </Form>
      </Card>

      {/* Feedback Submitted Modal */}
      <Modal
        title="Thank You!"
        open={isModalVisible}
        onOk={handleModalOk}
        onCancel={handleModalOk}
        okText="Close"
        centered
      >
        <p>Your feedback has been submitted successfully.</p>
      </Modal>
    </div>
  );
};

export default AboutMe;
